module.exports = __webpack_public_path__ + "static/media/insert_photo-24px.c215adc6.svg";